export default __webpack_public_path__ + "static/media/nb.3cba8c99.png";